import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "./app/store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import App from "./App";
import "./index.css";
import ScrollToTopNewPage from "./components/ScrollToTopNewPage";

const container = document.getElementById("root");
const root = createRoot(container);
let persistor = persistStore(store)

root.render(
  <React.StrictMode>
      <BrowserRouter>
        <ReduxProvider store={store}>
          <PersistGate persistor={persistor}>
            <ScrollToTopNewPage />
            <App />
          </PersistGate>
        </ReduxProvider>
      </BrowserRouter>
  </React.StrictMode>
);
